var encrypt = require('./encrypt');

var class2type = (function () {
  var class2type = {};
  var arr = "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ");
  arr.forEach(function (name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });
  return class2type;
})();

var _type = function (obj) {
  if (obj == null) {
    return obj + "";
  }
  return typeof obj === "object" || typeof obj === "function" ?
    class2type[{}.toString.call(obj)] || "object" :
    typeof obj;
};

var isArray = Array.isArray;

var isFunction = function (obj) {
  return _type(obj) === "function";
};

var isPlainObject = function (obj) {
  return _type(obj) === 'object';
};

var extend = function () {
  var src, copyIsArray, copy, name, options, clone,
    target = arguments[0] || {},
    i = 1,
    length = arguments.length,
    deep = false;

  // Handle a deep copy situation
  if (typeof target === "boolean") {
    deep = target;

    // skip the boolean and the target
    target = arguments[i] || {};
    i++;
  }

  // Handle case when target is a string or something (possible in deep copy)
  if (typeof target !== "object" && !isFunction(target)) {
    target = {};
  }

  // extend jQuery itself if only one argument is passed
  if (i === length) {
    target = this;
    i--;
  }

  for (; i < length; i++) {

    // Only deal with non-null/undefined values
    if ((options = arguments[i]) != null) {

      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name];

        // Prevent never-ending loop
        if (target === copy) {
          continue;
        }

        // Recurse if we're merging plain objects or arrays
        if (deep && copy && (isPlainObject(copy) ||
          (copyIsArray = isArray(copy)))) {

          if (copyIsArray) {
            copyIsArray = false;
            clone = src && isArray(src) ? src : [];

          } else {
            clone = src && isPlainObject(src) ? src : {};
          }

          // Never move original objects, clone them
          target[name] = extend(deep, clone, copy);

          // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  // Return the modified object
  return target;
};

var each = function (obj, callback) {
  var length, i = 0;

  if (isArray(obj)) {
    length = obj.length;
    for (; i < length; i++) {
      if (callback.call(obj[i], i, obj[i]) === false) {
        break;
      }
    }
  } else {
    for (i in obj) {
      if (callback.call(obj[i], i, obj[i]) === false) {
        break;
      }
    }
  }

  return obj;
};

/*string转换为number,进行比较*/
var strToNumCompare = function (str1, str2) {
  var result = 0;
  var nagative;
  if (!str1 && !str2) {
    return result;
  }
  if (isNaN(str1) || isNaN(str2)) {
    return null;
  }

  str1 = str1 + '';
  str2 = str2 + '';
  // 负数
  if (str1.charAt(0) == '-' && str2.charAt(0) != '-') {
    result = -1;
    return result;
  } else if (str1.charAt(0) != '-' && str2.charAt(0) == '-') {
    result = 1;
    return result;
  }
  if (str1.charAt(0) == '-' && str2.charAt(0) == '-') {
    str1 = str1.substring(1);
    str2 = str2.substring(1);
    nagative = true;
  }
  var len1 = str1.length;
  var len2 = str2.length;
  if (len1 > len2) {
    result = 1;
  } else if (len1 < len2) {
    result = -1;
  } else if (len1 == len2) {
    for (var i = 0; i < len1; i++) {
      if (str1.charAt([i]) > str2.charAt([i])) {
        result = 1;
        break;
      } else if (str1.charAt([i]) < str2.charAt([i])) {
        result = -1;
        break;
      } else if (str1.charAt([i]) == str2.charAt([i])) {
        continue;
      }
    }
  }

  if (nagative) {
    result = result == 1 ? -1 : result == -1 ? 1 : 0;
  }
  return result;
};

// ajax请求
var param = function (obj) {
  var list = [];
  for (var key in obj) {
    var value = obj[key];
    value = value == null ? '' : value;
    list[list.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }
  var r20 = /%20/g;
  return list.join('&').replace(r20, '+');
};
var getXhrObj = function () {
  var xhr;
  if (window.XMLHttpRequest) {
    xhr = new XMLHttpRequest();
  } else {
    // IE6及其以下版本
    xhr = new ActiveXObject('Microsoft.XMLHTTP');
  }
  return xhr;
};
var callBackName = function () {
  var expando = 'Callback' + (Math.random() + '').replace(/\D/g, '');
  return expando + '_' + (new Date().getTime());
};
var json = function (params) {
  // 数据请求类型
  params.type = (params.type || 'GET').toUpperCase();
  // 格式化query传输数据
  params.query = param(params.query);
  // Post数据转换为字符串
  params.data = params.data instanceof Blob ? params.data : params.data && JSON.stringify(params.data);
  // Post数据加密
  if (params.encrypt && params.data) {
    params.data = encrypt(params.data);
  }

  var xhr = getXhrObj();

  // 监听xhr状态改变
  xhr.onreadystatechange = function () {
    // 完成
    if (xhr.readyState == 4) {
      var status = xhr.status;
      // status:http状态码，以2开头都是成功
      if (status >= 200 && status < 300) {
        var response = '';
        // 判断返回值的消息类型
        var type = xhr.getResponseHeader('Content-type');
        var eTag = xhr.getResponseHeader('ETag');
        if (type && type.indexOf('xml') !== -1 && xhr.responseXML) {
          // xml对象
          response = xhr.responseXML;
        } else if (type === 'application/json') {
          // JSON字符串
          response = JSON.parse(xhr.responseText);
        } else {
          response = {
            text: xhr.responseText,
            eTag: eTag
          };
        }

        // 对于设置dataType的类型进行限制
        if (params.dataType == 'json' && type != 'application/json') {
          // 失败回调
          params.complete && params.complete();
          params.error && params.error(xhr, status, { message: 'not json type error' });
        } else {
          // 成功回调
          params.complete && params.complete();
          params.success && params.success(response);
        }
      } else {
        // 失败回调
        params.complete && params.complete();
        params.error && params.error(xhr, status, 'failed!');
      }
    }
  };

  var query;
  // 加密处理
  if (params.encrypt && params.query) {
    query = params.url + '?params=' + encrypt(params.query) + '&version=' + encrypt.getVersion();
  } else {
    query = params.query ? params.url + '?' + params.query : params.url;
  }

  xhr.open(params.type, query, true);// xhr.open(请求方式、请求地址、是否异步请求）
  // GET请求
  if (params.type == 'GET') {
    xhr.send(null);
  } else {
    var contentType = params.contentType ? params.contentType : 'application/x-www-form-urlencoded;charset=UTF-8';
    xhr.setRequestHeader('Content-type', contentType);
    xhr.send(params.data);
  }
};
var jsonp = function (params) {
  // 数据请求类型
  params.type = (params.type || 'GET').toUpperCase();
  // 在query中添加回调函数名称
  params.query = params.query ? params.query : {};
  // 回调函数名称
  var callbackName = params.jsonp ? params.jsonp : callBackName();
  params.query['callback'] = callbackName;
  // query数据格式
  params.query = param(params.query);


  // 创建script标签并插入到页面
  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  head.appendChild(script);

  // jsonp的回调函数
  // 在window对象上定义回调方法
  window[callbackName] = function (jsondata) {
    head.removeChild(script);
    clearTimeout(script.timer);
    window[callbackName] = null;
    // 成功回调
    params.complete && params.complete();
    params.success && params.success(jsondata);
  };

  // 发送请求
  if (params.encrypt && params.query) {
    script.src = params.url + '?params=' + encrypt(params.query) + '&version=' + encrypt.getVersion();
  } else {
    script.src = params.url + '?' + params.query;
  }
  console.log('==================== script.src:', script.src);

  // 请求是否成功，设置超时处理
  if (params.timeout) {
    script.timer = setTimeout(function () {
      window[callbackName] = null;
      head.removeChild(script);
      params.complete && params.complete();
      params.error && params.error(null, 'failed', { message: 'timeout!' });
    }, timeout);
  }

  // 监听script标签加载是否成功
  script.onerror = function () {
    params.complete && params.complete();
    params.error && params.error(null, 'failed', { message: 'script onload error!' });
  }
};
var ajax = function (params) {
  params = params || {};
  // 对json和jsonp请求做不同处理
  if (params.jsonp || (params.dataType && params.dataType == 'jsonp')) {
    jsonp(params);
  } else {
    json(params);
  }
};

/**
 * 实现类与类之间的继承。
 * @method inherits
 * @grammar Base.inherits( super ) => child
 * @grammar Base.inherits( super, protos ) => child
 * @grammar Base.inherits( super, protos, statics ) => child
 * @param  {Class} super 父类
 * @param  {Object | Function} [protos] 子类或者对象。如果对象中包含constructor，子类将是用此属性值。
 * @param  {Function} [protos.constructor] 子类构造器，不指定的话将创建个临时的直接执行父类构造器的方法。
 * @param  {Object} [statics] 静态属性或方法。
 * @return {Class} 返回子类。
 * @example
 * function Person() {
     *     console.log( 'Super' );
     * }
 * Person.prototype.hello = function() {
     *     console.log( 'hello' );
     * };
 *
 * var Manager = Base.inherits( Person, {
     *     world: function() {
     *         console.log( 'World' );
     *     }
     * });
 *
 * // 因为没有指定构造器，父类的构造器将会执行。
 * var instance = new Manager();    // => Super
 *
 * // 继承子父类的方法
 * instance.hello();    // => hello
 * instance.world();    // => World
 *
 * // 子类的__super__属性指向父类
 * console.log( Manager.__super__ === Person );    // => true
 */
var inherits = function (Super, protos, staticProtos) {
  var child;

  if (typeof protos === 'function') {
    child = protos;
    protos = null;
  } else if (protos && protos.hasOwnProperty('constructor')) {
    child = protos.constructor;
  } else {
    child = function () {
      return Super.apply(this, arguments);
    };
  }

  // 复制静态方法
  extend(child, Super, staticProtos || {});

  // 让子类的__super__属性指向父类。
  child.__super__ = Super.prototype;

  // 构建原型，添加原型方法或属性。
  child.prototype = Object.create(Super.prototype);
  child.prototype._super = Super;
  protos && extend(true, child.prototype, protos);

  return child;
};

var convertBase64UrlToFile = function (urlData, fileName){
  var arr = urlData.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  var blob = new Blob([u8arr], {type:mime});
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  return blob;
}

module.exports = {
  extend: extend,
  each: each,
  param: param,
  ajax: ajax,
  inherits: inherits,
  strToNumCompare: strToNumCompare,
  fnEmpty: function () {
  },
  convertBase64UrlToFile: convertBase64UrlToFile
};
